<template>
  <span>
    <HfDropdown
      aria-role="list"
      class="hf-dropdown"
    >
      <template #trigger>
        <button
          class="button is-info"
          type="button"
        >
          {{ $t(`leagueIdLong.${context.focusLeagueId}`) }}
          <HfIcon
            icon="caret-down"
            size="is-small"
          />
        </button>
      </template>
      <HfDropdownItem
        v-for="leagueId in leagueIds"
        :key="leagueId"
        @click="context.setFocusLeagueId(leagueId)"
      >
        {{ $t(`leagueIdLong.${leagueId}`) }}
      </HfDropdownItem>
    </HfDropdown>
  </span>
</template>

<script setup lang="ts">
  import {LeagueId} from '@/model/core/core-data.model';
  import {useContextStore} from '@/store/context.store';
  import HfDropdown from '@/components/ui/HfDropdown.vue';
  import HfDropdownItem from '@/components/ui/HfDropdownItem.vue';
  import HfIcon from '@/components/ui/HfIcon.vue';

  const context = useContextStore();

  const leagueIds: LeagueId[] = ['a', 'b'];
</script>
